<template>
  <BaseListItem>
    <div class="flex -mx-3 p-4">
      <div class="flex-1 px-3 capitalize">
        <span>{{ entity.name }}</span>
      </div>
    </div>
  </BaseListItem>
</template>

<script>
export default {
  props: {
    entity: {
      type: Object,
      required: true,
    },
  },
};
</script>
